import { render, staticRenderFns } from "./projectBiddingNotice.vue?vue&type=template&id=371ab23f&scoped=true"
import script from "./projectBiddingNotice.vue?vue&type=script&lang=js"
export * from "./projectBiddingNotice.vue?vue&type=script&lang=js"
import style0 from "./projectBiddingNotice.vue?vue&type=style&index=0&id=371ab23f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371ab23f",
  null
  
)

export default component.exports